import React, { useMemo } from 'react';

import { EmptyState, Screen } from '../design/components';

/**
 * Loading, error and empty states for a DetailContainer screen that draws its
 * own redesign `Screen`, so the header (back and menu) stays usable before the
 * data arrives. Pass the result's components as DetailContainer props.
 * frame: Screen header/footer props shared with the loaded screen
 * ({ backLabel, onBack, banner, headerRight }).
 */
const useFramedDetailStates = ({ backLabel, onBack, banner, headerRight } = {}) => useMemo(() => {
	const frame = { backLabel, onBack, banner, headerRight };

	return {
		LoadingComponent: () => <Screen {...frame} isLoading={true} />,
		ErrorComponent: ({ refetch }) => (
			<Screen
				{...frame}
				error="Check your connection and try again."
				onRetry={refetch ? () => refetch() : undefined}
			/>
		),
		NoDataComponent: () => (
			<Screen {...frame}>
				<EmptyState title="Nothing to show here yet" />
			</Screen>
		),
	};
}, [backLabel, banner, headerRight, onBack]);

export default useFramedDetailStates;
